import React from 'react';
import { BadgeCheckIcon, SmartphoneIcon, TabletIcon, LaptopIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { OptimizedImage } from '../OptimizedImage';
import { images, BUYERS_COUNT } from '../../data/content';
export function Hero() {
  return <section id="top" className="relative overflow-hidden bg-brand-950 text-white" data-id="element-293" data-mp="huxsjtb3wrxq">
      <div className="mx-auto max-w-5xl px-5 pb-12 pt-8 text-center sm:pt-12 lg:pb-20" data-id="element-294" data-mp="hsut6io2dmgc">
        <h1 className="mx-auto max-w-4xl font-display text-[30px] font-extrabold leading-[1.08] tracking-tight sm:text-5xl lg:text-[58px]" data-id="element-295" data-mp="mtsbcv92qghu">
          ¿Trabajás o querés empezar a trabajar con <span className="text-sun" style={{
          color: "#FFE17A"
        }} data-id="element-296" data-mp="vmvvtni4ztlz">adultos mayores?</span>
        </h1>
        <p className="mx-auto mt-4 max-w-3xl font-display text-lg font-extrabold uppercase leading-snug tracking-tight text-brand-100 sm:text-2xl" data-id="element-297" data-mp="10kxe467qnowe">
          Preparate para incorporar la actividad física a tu perfil profesional
        </p>

        <OptimizedImage src={images.mockup} alt="Mockup de Reactiva tu Cuerpo: caja del programa, planillas de planificación, rutinas por nivel, laptop con los módulos, tablet y celular" width={1254} height={1254} priority className="mx-auto mt-6 aspect-square h-auto w-[70%] max-w-[434px] object-contain drop-shadow-[0_40px_50px_rgba(23,49,59,0.5)]" data-id="element-298" data-mp="9nt141biopiy" />

        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white sm:text-lg" data-id="element-299" data-mp="3rv0ai53ao2k6">
          Aprendé a planificar y aplicar ejercicios, actividades y sesiones orientadas a adultos mayores, y sumá nuevas herramientas para{' '}
          <strong className="font-semibold text-sun" style={{
          color: "#FFE17A"
        }} data-id="element-300" data-mp="iohequx00nvb">ampliar tus oportunidades laborales , mejorar tus servicios profesionales y aumentar tus ingresos.</strong>
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-brand-100 sm:text-base" data-id="element-301" data-mp="1b4s2aotr7jy8">
          REACTIVA TU CUERPO™ es una formación que reúne en un solo lugar ejercicios, actividades, rutinas, planificación y recursos prácticos para ayudarte a trabajar con personas mayores.
        </p>

        <ul className="mx-auto mt-6 grid max-w-xl grid-cols-3 rounded-2xl bg-white/5 ring-1 ring-white/10" data-id="element-302" data-mp="35l0j1vj00j57">
          <li className="px-2 py-3" data-id="element-303" data-mp="2qwdssyru26z7">
            <p className="font-display text-2xl font-extrabold leading-none text-sun sm:text-3xl" style={{
            color: "#FFE17A"
          }} data-id="element-304" data-mp="2qvckh227byl6">7</p>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-wider text-brand-100" data-id="element-305" data-mp="2vt4d5yao7oqf">Módulos</p>
          </li>
          <li className="relative border-l border-white/10 px-2 py-3" data-id="element-306" data-mp="2muis9whq7xmh">
            <span className="absolute -left-2.5 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center rounded-full bg-sun font-display text-xs font-extrabold text-ink" aria-hidden="true" style={{
            backgroundColor: "#F7C325",
            backgroundImage: "none"
          }} data-id="element-307" data-mp="2msfuure8v27q">
              +
            </span>
            <p className="font-display text-2xl font-extrabold leading-none text-sun sm:text-3xl" style={{
            color: "#FFE17A"
          }} data-id="element-308" data-mp="63sjj7ehqemt">5</p>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-wider text-brand-100" data-id="element-309" data-mp="1vmr1i7ughpta">Bonos</p>
          </li>
          <li className="relative border-l border-white/10 px-2 py-3" data-id="element-310" data-mp="1qop92wb54e55">
            <span className="absolute -left-2.5 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center rounded-full bg-sun font-display text-xs font-extrabold text-ink" aria-hidden="true" style={{
            backgroundColor: "#F7C325",
            backgroundImage: "none"
          }} data-id="element-311" data-mp="25ctui81kv3rm">
              +
            </span>
            <p className="flex items-center justify-center gap-1 font-display text-2xl font-extrabold leading-none text-sun sm:text-3xl" style={{
            color: "#FFE17A"
          }} data-id="element-312" data-mp="2abwyrq9qh5yj">
              {BUYERS_COUNT}
              <BadgeCheckIcon className="h-4 w-4 shrink-0 sm:h-5 sm:w-5" aria-label="Verificado" data-id="element-313" data-mp="2jclecperzedj" />
            </p>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-wider text-brand-100" data-id="element-314" data-mp="txf0nd4o0s0q">Compradores</p>
          </li>
        </ul>

        <div className="mx-auto mt-7 flex max-w-md flex-col items-stretch gap-2.5 sm:max-w-none sm:items-center" data-id="element-315" data-mp="ozvii24ujv3i">
          <CtaButton size="lg" data-id="element-316" data-mp="qfhghob4fcjc" />
          <p className="flex items-center justify-center gap-2 text-sm text-brand-100" data-id="element-317" data-mp="veu0m1aly5i8">
            <span className="flex items-center gap-1 text-sun" aria-hidden="true" data-id="element-318" data-mp="vgnd3x7wjjy5">
              <SmartphoneIcon className="h-4 w-4" data-id="element-319" data-mp="10bu90iuxjkci" />
              <TabletIcon className="h-4 w-4" data-id="element-320" data-mp="15d9ugc10rsvf" />
              <LaptopIcon className="h-4 w-4" data-id="element-321" data-mp="15axeu5iqhulj" />
            </span>
            Celular, tablet o computadora.
          </p>
        </div>
      </div>
    </section>;
}